import SignupModal from '@/components/_rebrand/TrialForm/Modal';
import { OPTIMIZELY_PAGES } from '@/constants/optimizely';
import { GlobalContext } from '@/context';
import optimizely from '@/lib/optimizely';
import { FC, useContext, useEffect } from 'react';

const TrialModal: FC = () => {
  const { showTrialModal, toggleTrialModal } = useContext(GlobalContext);

  useEffect(() => {
    if (showTrialModal) {
      const deactivate1 = optimizely.activatePage(OPTIMIZELY_PAGES.ANY_GET_STARTED_MODAL);
      const deactivate2 = optimizely.activatePage(OPTIMIZELY_PAGES.TRIAL_MODAL);

      return () => {
        deactivate1();
        deactivate2();
      };
    }
  }, [showTrialModal]);

  return showTrialModal ? (
    <SignupModal
      onClose={() => {
        toggleTrialModal(false);
      }}
    />
  ) : null;
};

export default TrialModal;
